import type { Vec3 } from "@dust/world/internal";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useDustClient } from "../hooks/useDustClient";

export function useCursorQuery() {
  const { data: dustClient } = useDustClient();
  return useQuery<Vec3 | null>({
    queryKey: ["cursor", "position"],
    queryFn: !dustClient
      ? skipToken
      : async () => {
          try {
            const cursor = await dustClient.provider.request({
              method: "getCursorPosition",
            });

            if (!cursor) {
              return null;
            }

            return [
              Math.floor((cursor.x ?? 0) / 16),
              Math.floor((cursor.y ?? 0) / 16),
              Math.floor((cursor.z ?? 0) / 16),
            ];
          } catch (e) {
            console.error("Error fetching cursor", e);
            return null;
          }
        },
    enabled: !!dustClient,
    refetchIntervalInBackground: true,
    refetchInterval: 100,
    staleTime: 0,
    gcTime: 0,
  });
}
